var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	3155: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	8642: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	103: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	173: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(203), __webpack_require__.e(148)]).then(() => (() => (__webpack_require__(1961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/core",

	},
	3238: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5306))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	9903: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(402))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	4683: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(9264))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "jotai",

	},
	8415: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	9762: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3710))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	9743: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	9203: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5257))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/icons",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"103": [
		103
	],
	"155": [
		3155
	],
	"203": [
		9203
	],
	"298": [
		173,
		3238,
		9903,
		4683,
		8415,
		9762,
		9743
	],
	"642": [
		8642
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}